
import Router from './Router';
import { Toaster } from 'sonner';
import "react-chat-elements/dist/main.css"
import ChatUs from './components/ChatUs';
import NotificationInitializer from './components/NotificationInitializer';
import ThemeProvider from './components/ThemeProvider';

function App() {
  return (
    <ThemeProvider>
      <div>
        <Toaster
          position="top-center"
          richColors
          closeButton
          expand={false}
          duration={3500}
          toastOptions={{
            style: {
              fontSize: '13.5px',
              fontWeight: '500',
              borderRadius: '12px',
              padding: '12px 16px',
            },
          }}
        />
        <NotificationInitializer />
        <Router />
        {/* <ChatUs /> */}
      </div>
    </ThemeProvider>
  );
}

export default App;
